module.exports = __webpack_public_path__ + "public/img/kuaishou.5ff1241b.png";